export const ROLE_REGIONS = {
  UK: 'UK',
  US: 'US',
};

// Base roles with UK rates (original data)
export const roles = [
  { key: 'seniorManager', label: 'Senior Manager', hourlyRate: 130 },
  { key: 'productManager', label: 'Product Manager', hourlyRate: 100 },
  { key: 'productDesigner', label: 'Product Designer', hourlyRate: 90 },
  { key: 'dataAnalyst', label: 'Data Analyst', hourlyRate: 70 },
  { key: 'engineeringManager', label: 'Engineering Manager', hourlyRate: 120 },
  { key: 'deliveryManager', label: 'Delivery Manager', hourlyRate: 110 },
  { key: 'seniorSoftwareEngineer', label: 'Senior Software Engineer', hourlyRate: 100 },
  { key: 'juniorSoftwareEngineer', label: 'Junior Software Engineer', hourlyRate: 50 },
];

// US rates with appropriate salary brackets
const US_RATES = {
  seniorManager: 175,
  productManager: 135,
  productDesigner: 120,
  dataAnalyst: 95,
  engineeringManager: 160,
  deliveryManager: 145,
  seniorSoftwareEngineer: 135,
  juniorSoftwareEngineer: 65,
};

// Legacy function - maintains backward compatibility
export const getHourlyRate = (roleKey) => {
  const match = roles.find((role) => role.key === roleKey);
  return match ? match.hourlyRate : 0;
};

// New region-aware function
export const getHourlyRateByRegion = (roleKey, region = ROLE_REGIONS.UK) => {
  if (region === ROLE_REGIONS.US && US_RATES[roleKey]) {
    return US_RATES[roleKey];
  }
  
  // Default to UK rates for UK region or invalid regions
  const match = roles.find((role) => role.key === roleKey);
  return match ? match.hourlyRate : 0;
};

// Returns roles array with region-specific rates
export const getRolesByRegion = (region = ROLE_REGIONS.UK) => {
  return roles.map(role => ({
    ...role,
    hourlyRate: getHourlyRateByRegion(role.key, region)
  }));
};
